import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { ArchiveSurveyActivity } from 'modules/engagement_surveys/activities/ArchiveSurvey'
import { DeleteSurveyActivity } from 'modules/engagement_surveys/activities/DeleteSurvey'
import { DuplicateSurveyActivity } from 'modules/engagement_surveys/activities/DuplicateSurvey'
import { FinishSurveyActivity } from 'modules/engagement_surveys/activities/FinishSurvey'
import { PublishSurveyActivity } from 'modules/engagement_surveys/activities/PublishSurvey'
import { ScheduleSettingsActivity } from 'modules/engagement_surveys/activities/ScheduleSettings'
import { SurveySettingsActivity } from 'modules/engagement_surveys/activities/SurveySettings'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  activities: {
    duplicateSurvey: {
      component: DuplicateSurveyActivity,
    },
    deleteSurvey: {
      component: DeleteSurveyActivity,
    },
    archiveSurvey: {
      component: ArchiveSurveyActivity,
    },
    finishSurvey: {
      component: FinishSurveyActivity,
    },
    publishSurvey: {
      component: PublishSurveyActivity,
    },
    scheduleSettings: {
      component: ScheduleSettingsActivity,
    },
    surveySettings: {
      component: SurveySettingsActivity,
    },
  },
} as const satisfies DomainManifest
